import { useEffect, useState } from 'react'

export type Brand = 'WOWVEGAS' | 'ROLLA'
export type BrandFilter = Brand | 'ALL'

const STORAGE_KEY = 'recon.brand'

export const BRANDS: Brand[] = ['WOWVEGAS', 'ROLLA']

export function readBrandFilter(): BrandFilter {
  const v = localStorage.getItem(STORAGE_KEY)
  if (v === 'WOWVEGAS' || v === 'ROLLA' || v === 'ALL') return v
  return 'ALL'
}

export function writeBrandFilter(b: BrandFilter) {
  localStorage.setItem(STORAGE_KEY, b)
  window.dispatchEvent(new Event('recon.brand.changed'))
}

// Shared hook: pages re-render when brand changes.
export function useBrandFilter(): [BrandFilter, (b: BrandFilter) => void] {
  const [b, setB] = useState<BrandFilter>(() => readBrandFilter())
  useEffect(() => {
    const onChange = () => setB(readBrandFilter())
    window.addEventListener('recon.brand.changed', onChange)
    return () => window.removeEventListener('recon.brand.changed', onChange)
  }, [])
  return [
    b,
    (next) => {
      writeBrandFilter(next)
      setB(next)
    },
  ]
}

// Convert UI filter to DB param: 'ALL' → null (RPC treats null as no filter)
export function brandParam(b: BrandFilter): string | null {
  return b === 'ALL' ? null : b
}

export function displayBrand(b: string | null | undefined): string {
  if (!b) return '—'
  if (b === 'WOWVEGAS') return 'WOW Vegas'
  if (b === 'ROLLA') return 'Rolla'
  return b
}
